import React from 'react';

import { faTrainSubway } from '@fortawesome/free-solid-svg-icons';

import AbstractIcon from '../abstract-icon';

const TrainIcon = () => <AbstractIcon icon={faTrainSubway} />;

export default TrainIcon;